import { clsx } from 'clsx'
import { Typography } from 'components/typography'
import { TagReachModalProps, TypographyTypes } from 'interfaces'
import React from 'react'

export const TagReachModal: React.FC<TagReachModalProps> = ({ data }) => {
	return (
		<div className="border-2 border-blue-primary rounded-lg p-4 mt-4 h-[365px] overflow-y-auto scrollbar-thin scrollbar-thumb-gray-2 scrollbar-track-transparent">
			{data?.parent_tags.map(parent => (
				<div key={parent.tag_parent_id} className="py-2">
					<Typography
						title={parent.tag_name || ''}
						fontLeading="12/15"
						type={TypographyTypes.p}
						className={clsx('text-gray-8 text-base')}
					/>
					<div className="flex flex-col gap-2 border-b-2 border-gray-2 py-2 pl-4">
						{parent.tags_child.map(child => (
							<div
								className="flex justify-between items-center"
								key={child.tag_child_id}
							>
								<Typography
									title={child.tag_name}
									fontLeading="12/15"
									type={TypographyTypes.p}
									className={clsx(
										'text-gray-8 text-base font-medium truncate w-[300px]'
									)}
								/>
								<div className="px-3 py-1 border border-blue-primary rounded-lg text-center w-[60px]">
									<Typography
										title={child.count_followers.toString()}
										fontLeading="12/15"
										type={TypographyTypes.p}
										className={clsx('text-gray-8 text-base font-medium')}
									/>
								</div>
							</div>
						))}
					</div>
				</div>
			))}
			<div className="flex flex-col gap-2 py-2">
				{data?.independent_tags.map(independent => (
					<div
						className="flex justify-between items-center "
						key={independent.tag_independent_id}
					>
						<Typography
							title={independent.tag_name}
							fontLeading="12/15"
							type={TypographyTypes.p}
							className={clsx(
								'text-gray-8 text-base font-medium truncate w-[300px]'
							)}
						/>
						<div className="px-3 py-1 border border-blue-primary rounded-lg text-center w-[60px]">
							<Typography
								title={independent.count_followers.toString()}
								fontLeading="12/15"
								type={TypographyTypes.p}
								className={clsx('text-gray-8 text-base font-medium')}
							/>
						</div>
					</div>
				))}
			</div>
		</div>
	)
}
